module.exports = __webpack_public_path__ + "aprile-2.jpg?fbf38fa3d32fe551dcdfa57e0d776d58";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aprile-2.jpg
// module id = 147
// module chunks = 0